(() => {
  const searchForm = document.querySelector(".gh-search-form");
  const searchInput = document.querySelector(".gh-search-input");

  if (searchForm) {
    searchForm.addEventListener("submit", function (e) {
      e.preventDefault();
      const searchTerm = searchInput.value;
      if (searchTerm) {
        window.location.href = `/blog/search?q=${encodeURIComponent(searchTerm)}`;
      }
    });
  }
})();
